/**
 * Scroll-container heights for sticky-header tables (`DataTable` `maxHeight`).
 * The offset is the page chrome above the table plus the pagination below it;
 * `100dvh` on mobile (address-bar safe), `100vh` on desktop.
 */

/** Full-page list with PageHeader + tab bar + filters (e.g. Vehicles, Drivers). */
export const TABLE_MAXH_TABS = "max-h-[calc(100dvh-300px)] lg:max-h-[calc(100vh-300px)]";

/** Full-page list with just a PageHeader (no tab bar) — e.g. Clients, Companies. */
export const TABLE_MAXH_SIMPLE = "max-h-[calc(100dvh-260px)] lg:max-h-[calc(100vh-260px)]";

/**
 * Table nested under a page tab bar AND a section sub-header (taller chrome) —
 * e.g. Payments › Debit History, Settings › User Accounts.
 */
export const TABLE_MAXH_NESTED = "max-h-[calc(100dvh-380px)] lg:max-h-[calc(100vh-380px)]";
